import {Directive, DoCheck, Input, OnDestroy, OnInit} from '@angular/core';
import {FormGroup, NgModelGroup} from '@angular/forms';
import {BehaviorSubject, combineLatest, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[ngModelGroup][disabled]'
})
export class ModelGroupDisabledDirective implements DoCheck, OnDestroy, OnInit {
    protected readonly target$ = new BehaviorSubject<FormGroup>(undefined);
    protected readonly disabled$ = new BehaviorSubject<boolean>(false);
    // protected readonly modelDisabled$ = new BehaviorSubject<boolean>(false);
    protected readonly us$ = new Subject<void>();

    public constructor(
        protected readonly ngModelGroup: NgModelGroup
    ) { }

    public ngOnInit(): void {
        combineLatest(
            [
                this.target$,
                this.disabled$,
            ]
        )
            .pipe(
                takeUntil(this.us$),
            )
            .subscribe(([$model, $disabled]: [FormGroup, boolean]) => {
                if ($model) {
                    if ($disabled) {
                        if ($model.enabled) {
                            $model.disable();
                        }
                    } else {
                        if ($model.disabled) {
                            $model.enable();
                        }
                    }
                }
            });
    }

    public ngDoCheck(): void {
        if (this.ngModelGroup.control !== this.target$.value) {
            this.target$.next(this.ngModelGroup.control);
        }
    }

    public ngOnDestroy(): void {
        this.us$.next();
        this.us$.complete();
    }

    @Input()
    public set disabled($value: boolean) {
        if (this.disabled$.value !== $value) {
            this.disabled$.next($value);
        }
    }

    public get disabled(): boolean { return this.disabled$.value; }
}
